import {useEffect, useState} from "react"

export type SessionStorageHooks<T extends unknown> = readonly [
    value: T,
    setter: (value: T) => unknown
]

export function useSessionStorage<
    T extends unknown
>(key: string, initialValue: T): SessionStorageHooks<T> {
  const [storedValue, setStoredValue] = useState(initialValue)

  useEffect(() => {
    if (typeof initialValue === "function") {
        throw new Error("useSessionStorage hook does not support functions and objects that are not json-serializable")
    }
    const item = window.sessionStorage.getItem(key)
    if (item === null) {
        return
    }
    try {
        const parsed = JSON.parse(item)
        setStoredValue(parsed)
      } catch (error) {
        console.error("an error occurred when attempting to parse local storage value (Is it json-encoded).", error)
      }
  }, [])

  function setValue(value: T) {
    try {
      setStoredValue(value)
      const stringified = JSON.stringify(value)
      window.sessionStorage.setItem(key, stringified)
    } catch (error) {
      console.error("useSessionStorage only accepts json-serializable values", error)
    }
  }

  return [storedValue, setValue]
}